import { Component, inject } from '@angular/core'

import {
  BaseDialogComponent,
  ReusableDialogComponent,
  TypographyComponent,
} from '@hyperkit'

import { QueryViewService } from '../../../../../../services/reader/query-view.service'

@Component({
  standalone: true,
  selector: 'revert-confirmation-component',
  templateUrl: './revert-confirmation-dialog.component.html',
  styleUrls: ['./revert-confirmation-dialog.component.scss'],
  imports: [ReusableDialogComponent, TypographyComponent],
})
export class RevertConfirmationComponent extends BaseDialogComponent<
  void,
  boolean
> {
  private readonly queryView = inject(QueryViewService)

  /** Retrieve the original query text */
  public originalQuery = () => this.queryView.originalQuery()

  protected override initializeOptions(): void {
    this.options = {
      headerText: 'Revert Query',
      primaryButtonText: 'Yes, confirm revert',
      secondaryButtonText: 'Close',
    }
  }

  public onSubmit(): void {
    this.onPrimaryAction(true) // user confirmed
  }

  public onClose(): void {
    this.onSecondaryAction()
  }
}
